import React, { useState } from 'react';
import { bool, func, object, shape, string } from 'prop-types';
import template from 'url-template';
import { withRouter } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import classes from './InventoryTableRowMenu.module.css';

const ProfileCreateUrl = template.parse(
    '/iothub/profiles/niagara/new{?basAgent,company,selectedOBIXPath}'
);

const InventoryTableRowMenu = ({
    companyInfo,
    hidden,
    history,
    item,
    location,
    selectInventory,
    setDevice
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
        setDevice(item);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleNewProfile() {
        const selectedOBIXPath = item.oBIXPath;
        selectInventory(selectedOBIXPath);
        const { search } = location;
        const values = new URLSearchParams(search);
        history.push(ProfileCreateUrl.expand({
            basAgent:         values.get('basAgent'),
            company:          companyInfo.companyId,
            selectedOBIXPath: selectedOBIXPath
        }));
        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem onClick={handleNewProfile}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/SettingsFlat.svg"
                    />
                    Create New Profile
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

InventoryTableRowMenu.defaultProps = {
    hidden:               false,
    onNewProfile:         () => {},
    onUseExistingProfile: () => {},
    selectInventory:      () => {},
    setDevice:            () => {}
};

InventoryTableRowMenu.propTypes = {
    item: shape({
        oBIXPath: string.isRequired
    }),
    companyInfo:          object,
    hidden:               bool,
    history:              object,
    location:             object,
    onNewProfile:         func,
    onUseExistingProfile: func,
    selectInventory:      func,
    setDevice:            func
};

export default withRouter(InventoryTableRowMenu);
